import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface CancelConfirmDialogProps {
  open: boolean;
  itemsCount: number;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const CancelConfirmDialog = ({ open, itemsCount, isLoading, onClose, onConfirm }: CancelConfirmDialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Nevyplácet vybrané POJ</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Vybráno POJ: {itemsCount}. Zmizí ze seznamu k vyplacení a ve výkazu budou označena jako ZRUŠENO. Akci nelze vzít
        zpět.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ p: 3, justifyContent: 'center', gap: 2 }}>
      <Button onClick={onClose}>Zavřít</Button>
      <Button variant="contained" color="error" onClick={onConfirm} loading={isLoading}>
        Nevyplácet
      </Button>
    </DialogActions>
  </Dialog>
);
